import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface FloatingCtaProps {
  triggerId: string;
  onClick?: () => void;
}
export function FloatingCta({
  triggerId,
  onClick
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has been scrolled past (no longer intersecting from top)
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        setVisible(true);
      } else if (entry.isIntersecting) {
        setVisible(false);
      }
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-103" data-mp="14f6l9uis5ecm">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3" data-id="element-104" data-mp="14ddf0gc2ww55">
          <div className="mx-auto max-w-md" data-id="element-105" data-mp="21cdsffirc2s3">
            <motion.button type="button" onClick={onClick} animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-magenta px-5 py-4 text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_-4px_24px_-4px_rgba(214,41,110,0.6)]" data-id="element-106" data-mp="26bh077q4gn3r">
              Quiero el Oráculo por $12.99
              <ArrowRightIcon className="h-4 w-4" data-id="element-107" data-mp="3crt13gkbwj31" />
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}